import { Checkbox, Label } from "@woodmac-hycb/form-input";
import { Col, Row } from "@woodmac-hycb/layout";

function DaySelector({ setAlert, alert }) {

    const days = ['Su', 'M', 'T', 'W', 'Th', 'F', 'S'];

    const handleCheckBoxChange = (day) => {
        if (day === 'Su') {
            setAlert((alert) => ({ ...alert, daySu: alert.daySu ^ 1 }));
        } else if (day === 'M') {
            setAlert((alert) => ({ ...alert, dayM: alert.dayM ^ 1 }));
        } else if (day === 'T') {
            setAlert((alert) => ({ ...alert, dayT: alert.dayT ^ 1 }));
        } else if (day === 'W') {
            setAlert((alert) => ({ ...alert, dayW: alert.dayW ^ 1 }));
        } else if (day === 'Th') {
            setAlert((alert) => ({ ...alert, dayTh: alert.dayTh ^ 1 }));
        } else if (day === 'F') {
            setAlert((alert) => ({ ...alert, dayF: alert.dayF ^ 1 }));
        } else if (day === 'S') {
            setAlert((alert) => ({ ...alert, dayS: alert.dayS ^ 1 }));
        }
    };

    const isChecked = (day) => {
        if (day === 'Su') {
            return alert.daySu === 1;
        } else if (day === 'M') {
            return alert.dayM === 1;
        } else if (day === 'T') {
            return alert.dayT === 1;
        }
        else if (day === 'W') {
            return alert.dayW === 1;
        }
        else if (day === 'Th') {
            return alert.dayTh === 1;
        }
        else if (day === 'F') {
            return alert.dayF === 1;
        }
        else if (day === 'S') {
            return alert.dayS === 1;
        }
    }


    return (
        <Row gap={8}>
            {days.map((day, index) => (
                <Col gap={4} alignItems="center" key={index}>
                    <Checkbox
                        id={index}
                        value={day}
                        checked={isChecked(day)}
                        onChange={() => handleCheckBoxChange(day)}
                    >
                    </Checkbox>
                    <Label>
                        {day}
                    </Label>
                </Col>
            ))}
        </Row>
    )
}

export default DaySelector;